<form class="form-horizontal" [formGroup]="nameForm" (ngSubmit)="onSubmit()">

    <app-loading-spinner [isLoading]="daveningService.loading()"></app-loading-spinner>

    <!-- ================= ENGLISH NAME ================= -->
    <div formGroupName="name">

        <div class="form-group row name-row align-items-center">

            <!-- Error on big screen only-->
            <div class="col-md-2 help-block text-center big-screen-only">
                <span *ngIf="nameForm.get('name.english1')?.errors?.['pattern']">Invalid characters</span>
            </div>

            <!-- First name -->
            <div class="col-md-3">
                <input class="form-control text-center" formControlName="english1" placeholder="Name">
            </div>

             <!-- Error on small screen only -->
            <div class="col-md-2 help-block text-center small-screen-only">
                <span *ngIf="nameForm.get('name.english1')?.errors?.['pattern']">Invalid characters</span>
            </div>

            <!-- ben / bat -->
            <div class="col-md-2 text-center">
                <select class="form-control ben-select text-center" formControlName="benBat">
                    <option>ben</option>
                    <option>bat</option>
                </select>
            </div>

            <!-- Mother -->
            <div class="col-md-3">
                <input class="form-control text-center" formControlName="english2" placeholder="Mother's Name">
            </div>

            <!-- Error -->
            <div class="col-md-2 help-block text-center">
                <span *ngIf="nameForm.get('name.english2')?.errors?.['pattern']">Invalid characters</span>
            </div>

        </div>

        <!-- ================= HEBREW NAME ================= -->

        <div class="form-group row name-row align-items-center">

            <!-- Error on big screen only -->
            <div class="col-md-2 help-block text-center big-screen-only">
                <span *ngIf="nameForm.get('name.hebrew2')?.errors?.['pattern']">Invalid characters</span>
            </div>

            <!-- Mother's name (in big screens comes first)-->
            <div class="col-md-3 big-screen-only">
                <input class="form-control text-center hebrew" formControlName="hebrew2" placeholder="שם האם">
            </div>

            <!-- Name (in small screens name comes first)-->
            <div class="col-md-3 small-screen-only">
                <input class="form-control text-center hebrew" formControlName="hebrew1" placeholder="שם">
            </div>

            <!-- Error on small screen only -->
            <div class="col-md-2 help-block text-center small-screen-only">
                <span *ngIf="nameForm.get('name.hebrew1')?.errors?.['pattern']">Invalid characters</span>
            </div>

            <!-- בן / בת -->
            <div class="col-md-2 text-center">
                <select class="form-control ben-select hebrew" formControlName="benBatHebrew">
                    <option>בן</option>
                    <option>בת</option>
                </select>
            </div>

            <!-- Name (in big screens comes second)-->
            <div class="col-md-3 big-screen-only">
                <input class="form-control text-center hebrew" formControlName="hebrew1" placeholder="שם">
            </div>

            <!-- Mother's name (in small screens comes second)-->
            <div class="col-md-3 small-screen-only">
                <input class="form-control text-center hebrew" formControlName="hebrew2" placeholder="שם האם">
            </div>

            <!-- Error on big screens, for name -->
            <div class="col-md-2 help-block text-center big-screen-only">
                <span *ngIf="nameForm.get('name.hebrew1')?.errors?.['pattern']">Invalid characters</span>
            </div>

            <!-- Error on small screens, for mother's name-->
            <div class="col-md-2 help-block text-center small-screen-only">
                <span *ngIf="nameForm.get('name.hebrew2')?.errors?.['pattern']">Invalid characters</span>
            </div>

        </div>

    </div>

    <div formGroupName="spouse">

        <div *ngIf="nameForm.get('category')?.value === 'banim'">

            <br>
            <h5 class="offset-md-2" [ngStyle]="{ color: spouseError ? 'var(--my-red)' : 'black' }">
                Please enter spouse's full name (English and/or Hebrew)
            </h5>

            <!-- ================= SPOUSE ENGLISH ================= -->

            <div class="form-group row name-row align-items-center">

                <!-- Spouse error on small screen only -->
                <div class="col-md-2 help-block text-center small-screen-only">
                    <span *ngIf="spouseEnglishError &&
                             !nameForm.get('spouse.english1')?.errors?.['pattern']">
                        Please complete spouse name
                    </span>
                </div>

                <!-- Error on big screen only -->
                <div class="col-md-2 help-block text-center big-screen-only">
                    <span *ngIf="nameForm.get('spouse.english1')?.errors?.['pattern']">
                        Invalid characters
                    </span>
                    <span *ngIf="spouseEnglishError &&
                             !nameForm.get('spouse.english1')?.errors?.['pattern']">
                        Please complete spouse name
                    </span>
                </div>

                <!-- Spouse name -->
                <div class="col-md-3">
                    <input class="form-control text-center" formControlName="english1" (keyup)="checkSpouse()"
                        placeholder="Spouse name">
                </div>

                <!-- character error on small screen only -->
                <div class="col-md-2 help-block text-center small-screen-only">
                    <span *ngIf="nameForm.get('spouse.english1')?.errors?.['pattern']">
                        Invalid characters
                    </span>
                </div>

                <!-- ben -->
                <div class="col-md-2 text-center">
                    <span class="form-control-static ben-static">ben</span>
                </div>

                <!-- Mother -->
                <div class="col-md-3">
                    <input class="form-control text-center" formControlName="english2" (keyup)="checkSpouse()"
                        placeholder="Spouse mother's name">
                </div>

                <!-- Error -->
                <div class="col-md-2 help-block text-center">
                    <span *ngIf="nameForm.get('spouse.english2')?.errors?.['pattern']">
                        Invalid characters
                    </span>
                </div>

            </div>

            <!-- ================= SPOUSE HEBREW ================= -->

            <div class="form-group row name-row align-items-center">

                <!-- Spouse error on small screen only for spouse name -->
                <div class="col-md-2 help-block text-center small-screen-only">
                    <span *ngIf="spouseHebrewError &&
                             !nameForm.get('spouse.hebrew1')?.errors?.['pattern']">
                        Please complete spouse name
                    </span>
                </div>

                <!-- Error on big screen only -->
                <div class="col-md-2 help-block text-center big-screen-only">
                    <span *ngIf="nameForm.get('spouse.hebrew2')?.errors?.['pattern']">
                        Invalid characters
                    </span>
                    <span *ngIf="spouseHebrewError &&
                             !nameForm.get('spouse.hebrew2')?.errors?.['pattern']">
                        Please complete spouse name
                    </span>
                </div>

                <!-- Mother (on big screens comes first) -->
                <div class="col-md-3 big-screen-only">
                    <input class="form-control text-center hebrew" formControlName="hebrew2" (keyup)="checkSpouse()"
                        placeholder="שם האם - של בן הזוג">
                </div>

                <!-- Spouse name (on small screens comes first)-->
                <div class="col-md-3 small-screen-only">
                    <input class="form-control text-center hebrew" formControlName="hebrew1" (keyup)="checkSpouse()"
                        placeholder="שם בן הזוג">
                </div>

                <!-- Character error on small screen only for spouse name -->
                <div class="col-md-2 help-block text-center small-screen-only">
                    <span *ngIf="nameForm.get('spouse.hebrew1')?.errors?.['pattern']">
                        Invalid characters
                    </span>
                </div>

                <!-- בן -->
                <div class="col-md-2 text-center">
                    <span class="form-control-static ben-static hebrew">בן</span>
                </div>

                <!-- Spouse name (on big screens comes second)-->
                <div class="col-md-3 big-screen-only">
                    <input class="form-control text-center hebrew" formControlName="hebrew1" (keyup)="checkSpouse()"
                        placeholder="שם בן הזוג">
                </div>

                <!-- Mother (on small screens comes second) -->
                <div class="col-md-3 small-screen-only">
                    <input class="form-control text-center hebrew" formControlName="hebrew2" (keyup)="checkSpouse()"
                        placeholder="שם האם - של בן הזוג">
                </div>

                <!-- Error (for spouse name on big screens only)-->
                <div class="col-md-2 help-block text-center big-screen-only">
                    <span *ngIf="nameForm.get('spouse.hebrew1')?.errors?.['pattern']">
                        Invalid characters
                    </span>
                </div>

                <!-- Error (for spouse's mother's name on small screens only) -->
                <div class="col-md-2 help-block text-center small-screen-only">
                    <span *ngIf="nameForm.get('spouse.hebrew2')?.errors?.['pattern']">
                        Invalid characters
                    </span>
                </div>

            </div>

        </div>
    </div>

    <!-- ================= CATEGORY ================= -->

    <div class="form-group text-center">
        <select formControlName="category" id="category" class="form-control w-auto mx-auto text-center"
            [ngStyle]="{ color: nameForm.get('category')?.value === '' ? 'var(--my-red)' : 'black' }" required>
            <option value="" disabled>Select category</option>
            <option *ngFor="let category of categories" style="color:black" [value]="category">
                {{ category | viewCategory }}
            </option>
        </select>
    </div>

    <!-- ================= URGENT NOTE ================= -->

    <div *ngIf="parentComp === 'urgent'" class="form-group row">
        <div class="col-md-6 offset-md-3">
            <textarea class="form-control" formControlName="note"
                placeholder="Here you can explain why this name is urgent (optional)">
        </textarea>
        </div>
    </div>

    <!-- ================= BUTTONS ================= -->

    <div class="form-group buttons">
        <button class="btn btn-ok btn-lg" type="submit" [disabled]="
                nameForm.get('name')?.invalid ||
                (nameForm.get('spouse')?.invalid &&
                 nameForm.get('category')?.value === 'banim') ||
                nameForm.get('category')?.invalid ||
                nameForm.get('email')?.invalid
            ">
            Submit Name
        </button>

        <button type="button" class="btn btn-danger btn-lg" (click)="cancel()">
            Cancel
        </button>
    </div>

</form>